module.exports = __webpack_public_path__ + "a4e734bc4fa65c09c7cd5cdb43fcc533.jpg";